import { c as _c } from "react/compiler-runtime";
import { GlowStatusBadge } from "@/shared/ui/glass";
import type { FeedbackStatus } from "@/domain/feature-announcement-feedback";
import { feedbackStatusTone, friendlyFeedbackStatus } from "../lib/format-feedback-status";

/**
 * The user-facing status progress badge. Self-contained: derives both the
 * friendly label and the glow tone from the raw status, so it works equally on
 * the list rows and the thread header (which has no server `friendlyStatus`).
 */
export function StatusBadge(t0) {
  const $ = _c(7);
  const {
    status
  } = t0;
  let t1;
  if ($[0] !== status) {
    t1 = feedbackStatusTone(status);
    $[0] = status;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== status) {
    t2 = friendlyFeedbackStatus(status);
    $[2] = status;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <GlowStatusBadge status={t1}>{t2}</GlowStatusBadge>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}